// ストレージ操作関連のハンドラー
import {
    saveSelectionState,
    restoreSelectionState,
    saveCategoryState,
    restoreCategoryState,
    saveLeftScroll,
    restoreLeftScroll,
    saveVariableValue,
    getVariableValue,
    restoreVariableValues,
    getSettings
} from '../state/app-state.js';
import { saveCurrentPCFromMainView } from './table-handlers.js';

/**
 * チェック状態を永続化（localStorage）
 */
export function saveSelectionStateLocal(): void {
    const currentSettings = getSettings();
    if (!currentSettings || !currentSettings.sections) return;

    const selectedIds: string[] = [];
    currentSettings.sections.forEach(section => {
        section.items.forEach(item => {
            const checkbox = document.getElementById(item.id) as HTMLInputElement | null;
            if (checkbox && checkbox.checked) {
                selectedIds.push(item.id);
            }
        });
    });

    saveSelectionState(selectedIds);
    
    // テーブルエディタでPCが選択されている場合は、そのPCの設定も更新
    saveCurrentPCFromMainView();
}

/**
 * チェック状態を復元（localStorage）
 */
export function restoreSelectionStateLocal(): void {
    const currentSettings = getSettings();
    if (!currentSettings) return;

    const ids = restoreSelectionState();
    if (!ids.length || !currentSettings.sections) return;

    const idSet = new Set(ids);
    currentSettings.sections.forEach(section => {
        section.items.forEach(item => {
            const checkbox = document.getElementById(item.id) as HTMLInputElement | null;
            if (checkbox) {
                checkbox.checked = idSet.has(item.id);
            }
        });
    });
}

/**
 * カテゴリ（親）とセクション（子）の開閉状態を保存
 */
export function saveCategoryStateLocal(): void {
    const state: Record<string, boolean> = {};
    // 親カテゴリ
    document.querySelectorAll('.category-content').forEach(el => {
        if (el.id) {
            state[el.id] = !el.classList.contains('hidden');
        }
    });
    // セクション（子）
    document.querySelectorAll('.section-content').forEach(el => {
        if (el.id) {
            state[el.id] = !el.classList.contains('hidden');
        }
    });

    saveCategoryState(state);
}

/**
 * カテゴリ（親）とセクション（子）の開閉状態を復元
 */
export function restoreCategoryStateLocal(): void {
    const state = restoreCategoryState();

    Object.entries(state).forEach(([id, open]) => {
        const content = document.getElementById(id);
        if (!content) return;
        const header = content.previousElementSibling;
        if (!header) return;

        // カテゴリかセクションかで矢印クラスを切り替え
        const arrow =
            id.startsWith('category_')
                ? header.querySelector('.category-arrow')
                : header.querySelector('.section-arrow');

        const shouldOpen = !!open;
        if (shouldOpen) {
            content.classList.remove('hidden');
            arrow?.classList.add('rotate-180');
        } else {
            content.classList.add('hidden');
            arrow?.classList.remove('rotate-180');
        }
    });
}

/**
 * 左カラム（倉庫）のスクロール位置を保存
 */
export function saveLeftScrollLocal(): void {
    const container = document.getElementById('settingsContainer');
    if (!container) return;
    saveLeftScroll(container.scrollTop || 0);
}

/**
 * 左カラム（倉庫）のスクロール位置を復元
 */
export function restoreLeftScrollLocal(): void {
    const container = document.getElementById('settingsContainer');
    if (!container) return;

    const scrollTop = restoreLeftScroll();
    container.scrollTop = scrollTop;
}

/**
 * 変数の値を保存（エクスポート用ラッパー）
 */
export function saveVariableValueLocal(itemId: string, varName: string, value: string): void {
    saveVariableValue(itemId, varName, value);
    
    // テーブルエディタでPCが選択されている場合は、そのPCの設定も更新
    saveCurrentPCFromMainView();
}

/**
 * 変数の値を取得
 */
export function getVariableValueLocal(itemId: string, varName: string, defaultValue: string = ''): string {
    return getVariableValue(itemId, varName, defaultValue);
}

/**
 * 変数の値を復元
 */
export function restoreVariableValuesLocal(): void {
    const currentSettings = getSettings();
    if (!currentSettings) return;
    
    const variables = restoreVariableValues();
    
    currentSettings.categories.forEach(category => {
        category.sections.forEach(section => {
            section.items.forEach(item => {
                if (item.variables && variables[item.id]) {
                    item.variables.forEach(variable => {
                        const storageKey = `var_${item.id}_${variable.name}`;
                        const input = document.getElementById(storageKey) as HTMLInputElement | null;
                        const itemVars = variables[item.id];
                        const varValue = itemVars?.[variable.name];
                        if (input && varValue !== undefined && typeof varValue === 'string') {
                            input.value = varValue;
                        }
                    });
                }
            });
        });
    });
}

